import { useMutation, useQuery } from "@tanstack/react-query";
import { SUCCESS_STATUS } from "../../../constants";
import * as api from "./api";
import type { DressChangeData, DressChangeFrequency } from "./api";

export const dressingChangeFrequencyQueryKeys = {
  detail: (params: api.DressingChangeFrequencyParams) =>
    ["patients", params.patientId, "assessments", params.assessmentId, "interventions", params.interventionId, "dressing-change-frequency"] as const,
};

const emptyFrequency: DressChangeFrequency = {};

export function useDressingChangeFrequency(params: api.DressingChangeFrequencyParams) {
  const query = useQuery({
    queryKey: dressingChangeFrequencyQueryKeys.detail(params),
    queryFn: () => api.fetchDressingChangeFrequency(params),
    enabled: Boolean(params.patientId && params.assessmentId && params.interventionId !== undefined),
    select: (envelope): DressChangeFrequency =>
      envelope.status === SUCCESS_STATUS ? { data: envelope.data as DressChangeData } : emptyFrequency,
  });

  return {
    ...query,
    isLoading: query.isLoading || query.isFetching,
    isRefreshing: !query.isLoading && query.isFetching,
  };
}

export function useUpdateDressingChangeFrequencyMutation() {
  return useMutation({
    mutationFn: api.updateDressingChangeFrequency,
  });
}
